// TODO, since the cache utils is not a public utils for FunkGo.
// it should be create as independent module once we have our own npm

export { createStorage as default } from '@flamingo_tech/funkgo'